export default __webpack_public_path__ + "static/media/969d7b98f43c81266ebb69b663c2ca2d.svg";